__turbopack_context__.v({
  "container": "TabbedContent-module__u9Ztiq__container",
  "fadeIn": "TabbedContent-module__u9Ztiq__fadeIn",
  "navLink": "TabbedContent-module__u9Ztiq__navLink",
  "navLinkActive": "TabbedContent-module__u9Ztiq__navLinkActive",
  "navLinkDisabled": "TabbedContent-module__u9Ztiq__navLinkDisabled",
  "navTabs": "TabbedContent-module__u9Ztiq__navTabs",
  "tabContent": "TabbedContent-module__u9Ztiq__tabContent",
  "tabContentNoPadding": "TabbedContent-module__u9Ztiq__tabContentNoPadding",
});
